import type { FaireProductEntity } from "../../entity_types/product";

export const p_5mwzt6dyam: FaireProductEntity = {
  token: "p_5mwzt6dyam",
  type: "product",
  name: "Cool Uncle Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/02deee1af295a44640a5598e4a78e4a71381b418e151d4db4767a3ba9e5f4f44.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13dab1d8277ead3442e11e4eda2e0d373af6f8ba2f442ce42b2c52dfb3b62c80.jpeg",
    "https://cdn.faire.com/fastly/d3262ef7eb5eb3bff7ef90b13ba685fdfbb82f1553a913338979a3bc3dfdcd66.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/3c960a7c17abb80748172e38b79fbb95e4cb5ee7ca7dc49cdb2eb447f6b2ee2e.jpeg",
    "https://cdn.faire.com/fastly/1c3212a922c030d367f7943c2eab618f643b6d75430ae59b5e9165703f938941.jpeg"
  ],
  priceDollars: 6.75,
  description: "Perfect for the fun, slightly irresponsible, but undeniably awesome uncle in your life. These socks are for the uncs that give high-fives instead of lectures.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:55.140Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
